import { alpha } from "@mui/material/styles"
import { Tooltip } from "@mui/material"
import { useTranslation } from "react-i18next"
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded"

import Chip from "widgets/common/Chip"

interface PlotRetryChipProps {
  hasPartialError: boolean
  isRetrying: boolean
  onClick: () => void
}

const PlotRetryChip = ({ hasPartialError, isRetrying, onClick }: PlotRetryChipProps) => {
  const { t } = useTranslation()
  const tone = hasPartialError ? "warning" : "error"

  return (
    <Tooltip
      title={
        hasPartialError
          ? t("error.PARTIAL_DATA_RETRY_TOOLTIP")
          : t("error.FAILED_TO_LOAD_RETRY_TOOLTIP")
      }
    >
      <Chip
        data-testid="plot-retry-chip"
        clickable
        onClick={onClick}
        disabled={isRetrying}
        title=""
        label={
          hasPartialError
            ? t("error.PARTIAL_DATA_RETRY")
            : t("error.FAILED_TO_LOAD_RETRY")
        }
        icon={<RefreshRoundedIcon />}
        sx={{
          flexShrink: 1,
          minWidth: 0,
          maxWidth: { xs: 150, sm: 190, md: 220 },
          backgroundColor: (theme) => theme.palette[tone].dark,
          borderColor: (theme) => theme.palette[tone].main,
          color: (theme) => theme.palette[tone].main,
          "& .MuiChip-icon": {
            color: (theme) => theme.palette[tone].main,
          },
          "& .MuiChip-label": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
          "&:hover": {
            backgroundColor: (theme) => alpha(theme.palette[tone].main, 0.28),
          },
        }}
      />
    </Tooltip>
  )
}

export default PlotRetryChip
